module.exports = __webpack_public_path__ + "static/media/EuclidCircularB-Medium-WebS.e93dc123.woff2";